/** Sent only after Victory Live accepts the price for every selected seat. */
export const VL_PRICE_UPDATE_SUCCESS_MESSAGE =
  'Price of all the selected tickets updated successfully';

export const VL_ID_MISMATCH_PRICE_ERROR = 'VL ID mismatch';

const VL_ID_MISMATCH_PATTERN = /vl ids are not matched|vl id'?s? are mismatch/i;

export const isVictoryLivePriceUpdateSuccess = (message: unknown): boolean =>
  String(message ?? '').trim() === VL_PRICE_UPDATE_SUCCESS_MESSAGE;

/** Prefer the VL id mismatch sentence over the generic price-update failure. */
export const priceUpdateFailureMessage = (
  message: unknown,
  fallback = 'Failed to update price on VL side please try again.',
): string => {
  const raw = String(message ?? '').trim();
  if (VL_ID_MISMATCH_PATTERN.test(raw)) return VL_ID_MISMATCH_PRICE_ERROR;
  return raw || fallback;
};
